import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { publicApi, currency, categoryMeta } from "@/lib/api";

export default function ProductCard({ product }) {
  const { data: categories = [] } = useQuery({ queryKey: ["categories"], queryFn: async () => (await publicApi.get("/categories")).data, staleTime: 300000 });
  const cat = categories.find((c) => c.slug === product.category)?.name || categoryMeta[product.category]?.label || product.category;
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="gold-card group block"
    >
      <div className="relative aspect-[4/3] overflow-hidden rounded-t-xl">
        <img
          src={product.image_urls?.[0]}
          alt={product.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-transparent to-transparent" />
        {product.featured && (
          <span className="absolute top-3 left-3 text-[10px] font-mono uppercase tracking-widest bg-gold text-ink px-3 py-1 rounded-full">
            Featured
          </span>
        )}
      </div>
      <div className="p-5">
        <p className="overline-label mb-1">{cat}</p>
        <h3 className="font-serif text-lg text-cream group-hover:text-gold transition-colors leading-snug">
          {product.name}
        </h3>
        <div className="mt-3 flex items-baseline justify-between">
          <span className="text-gold-bright font-semibold">{currency(product.price_per_day)}<span className="text-muted2 text-xs font-normal"> / day</span></span>
          <span className="text-xs text-muted2">{product.stock} in stock</span>
        </div>
      </div>
    </Link>
  );
}
